class Manager {
    constructor({ name, id = null, collection = {}, actions = {}, listUrl = ''}) {
        this.name = name;
        this.collection = collection;
        this.actions = actions;

        this.listUrl = listUrl;
        this.getItem = this.getItem.bind(this);
        this.getItems = this.getItems.bind(this);
        this.id = id;
    }

    getItem(id = null) {
        id = id || this.id || null;
        if (id) {
            return this.collection.items[id];
        }
    }

    getItems() {
        const { items, itemIds } = this.collection;
        return itemIds.map(id => items[id]);
    }
}

export default Manager;
